// charts/CustomTooltip.js
export const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload) return null;
  
    return (
      <div className="bg-white p-3 shadow rounded border">
        <p className="font-medium">{label}</p>
        {payload.map((entry, index) => (
          <div key={index} className="flex items-center mt-1">
            <div
              className="w-3 h-3 rounded-full mr-2"
              style={{ backgroundColor: entry.color }}
            />
            <span>
              {entry.name}: {entry.value}
            </span>
          </div>
        ))}
      </div>
    );
  };
  